import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import "./componentCss/adminHome.css";
import { useNavigate, BrowserRouter as Router, Route, Link } from "react-router-dom";

function AdminHome() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [DataTransfer, setData] = useState([]);
  const [all, setAll] = useState([]);
  const [count, setCount] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [allCustomer, setAllCustomer] = useState([]);
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const navigate = useNavigate();
  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) {
        return value;
      }
    }
    return null;
  }
  const filteredData = all.filter((row) =>
  !searchTerm ||
  row.access?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  row.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  row.opt_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  row.network?.toLowerCase().includes(searchTerm.toLowerCase())
);
const totalAmount = filteredData.reduce(
  (total, row) => total + Number(row.cost || 0),
  0
);
  const user = getCookie('user');
  if (!user) {
    navigate('/login');
  }
  const handleSearchSubmit = async (event) => {
    if (event) event.preventDefault();
    try {
      if (searchTerm) {
        console.log("Searching for:", searchTerm);
        const response = await axios.post("https://node.cabletvpay.in/customerSearch", { user, searchTerm });
        if (response.status === 200) {
          setAllCustomer(response.data.allCustomer);
        
        }
      } else { console.log("serached empty ", searchTerm); }
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching data");
    }
  };
 async function fetchUserData() {
  try {
    const response = await axios.post('https://node.cabletvpay.in/adminHome');
    if (response.status === 200) {
     console.log(response.data);
     setCount(response.data.count[0])
     setAll(response.data.all)
     }
  } catch (err) {
    setError(err.response?.data?.message || "Error fetching data");
    toast.error(err.response?.data?.message || "Error fetching data")
   console.log(err);
  } finally {
   setLoading(false);

 }
 }
useEffect(() => {
  fetchUserData();
 }, [user]);
 const togglePasswordVisibility = (id) => {
  setVisiblePasswords(prevState => ({
    ...prevState,
    [id]: !prevState[id]
  }));
};
  // if (loading) return (<div className="content-wrapper dark-mode">
  //   <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
  //     <RotatingLines visible={true} height="80" width="80" strokeColor="#f9f9ff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
  //   </div></div>)
  // if (error) return (<div className="content-wrapper dark-mode">
  //   <ToastContainer theme='dark' />
  //   <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
  //     <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
  //   </div></div>);
  return (
    <div className="content-wrapper dark-mode" >
      <section className="content-header pt-1">
      </section>
      <div className="container-fluid px-lg-5">
        <ToastContainer theme='dark' />
        <div className="overview p-3" style={{ backgroundColor: "rgb(48, 53, 58)", borderRadius: "15px" }}>
          <h2 className='mx-3 mb-3'>Overview</h2>
          <div className="row mx-2 ">
            <div className="col-lg-3 col-md-6 col-12 p-2">
              <div className="card w3-animate-zoom" style={{ backgroundColor: "#dff2fe", borderRadius: "15px" }}>
                <div className="d-flex justify-content-between mx-2" style={{ color: "black" }}>
                  <div className="d-flex-column">
                    <h6 className='text-bold  mt-3'>All Operator</h6>
                    {/* <h1 className='mt-2 ml-3 text-bold'>{count.paid_operators} / {count.total_operators}</h1> */}
                  </div>
                  <div className="my-auto pt-1 mx-2">
                    <i className='fa fa-users bg-black h4 img-circle' style={{ padding: "15px 13px" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 p-2">
              <div className="card w3-animate-zoom" style={{ backgroundColor: "rgb(207, 250, 229)", borderRadius: "15px" }}>
                <div className="d-flex justify-content-between mx-2" style={{ color: "black" }}>
                  <div className="d-flex-column">
                    <h6 className='text-bold mt-3'>Total Amount</h6>
                    {/* <h1 className='mt-2 ml-3 text-bold'> {count?.total_bill_amount ? Number(count.total_bill_amount).toLocaleString() : "0"}</h1> */}
                  </div>
                  <div className="my-auto pt-1 mx-2">
                    <i className='fa fa-rupee-sign bg-black h4 img-circle' style={{ padding: "14px 17px" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 p-2">
              <div className="card w3-animate-zoom" style={{ backgroundColor: "rgb(243, 232, 255)", borderRadius: "15px" }}>
                <div className="d-flex justify-content-between mx-2" style={{ color: "black" }}>
                  <div className="d-flex-column">
                    <h6 className='text-bold  mt-3'>Bill Generate</h6>
                    {/* <h1 className='mt-2 ml-3 text-bold'>{count.bill_generate}</h1> */}
                  </div>
                  <div className="my-auto pt-1 mx-2">
                    <i className='fa fa-receipt bg-black h4 img-circle' style={{ padding: "14px 16px" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 p-2">
              <div className="card w3-animate-zoom" style={{ backgroundColor: "rgb(255, 253, 232)", borderRadius: "15px" }}>
                <div className="d-flex justify-content-between mx-2" style={{ color: "black" }}>
                  <div className="d-flex-column">
                    <h6 className='text-bold  mt-3'>Add Operator</h6>
                    {/* <h1 className='mt-2 ml-3 text-bold'>?</h1> */}
                  </div>
                  <div className="my-auto pt-1 mx-2">
                    <i className='fa fa-user-plus bg-black h4 img-circle' style={{ padding: "15px 12px" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card mt-3">
        <div className="card-header py-3">
  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">

    {/* Title */}
    <h5 className="mb-0 text-bold text-white">
      Operator Details
    </h5>

    {/* Search Section */}
    <div className="d-flex align-items-center" style={{ maxWidth: "400px", width: "100%" }}>
      
      <input
        type="search"
        className="form-control border-0 bg-white shadow-sm"
        placeholder="🔍 Search operators..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          borderRadius: "8px 0 0 8px",
          height: "40px"
        }}
      />
    </div>

  </div>
</div>
          <div className="card-body">
           <table id="myTable" className="table table-striped table-bordered table-responsive-md">
  <thead className='text-navy text-capitalize text-bold' style={{ backgroundColor: "rgb(224, 224, 224)" }}>
    <tr>
      <th>S. No</th>
      <th>Payment</th>
      <th>Network Name</th>
      <th>Username</th>
      <th>Operator ID</th>
      <th>Password</th>
      <th>Customers</th>
      <th>SMS Count</th>
      <th>Bill Amount</th>
    </tr>
  </thead>

 <tbody>
  {filteredData.length > 0 ? (
    filteredData.map((row, index) => (
      <tr key={row.id}>
        <td>{index + 1}</td>

        <td>
          {row.status === "paid" ? (
            <button className="btn-sm btn-success">Paid</button>
          ) : (
            <Link to={`/AdminBillPayment/${row.network}`}>
              <button className="btn-sm btn-danger">UnPaid</button>
            </Link>
          )}
        </td>

        <td>{row.access}</td>
        <td>{row.username}</td>
        <td>{row.opt_id}</td>

        <td>
          <button
            className="btn-sm my-1 px-3 btn-primary"
            onClick={() => togglePasswordVisibility(row.id)}
          >
            {visiblePasswords[row.id] ? row.password : "****"}
          </button>
        </td>

        <td>{row.network}</td>
        <td>{row.allocated_sms}</td>
        <td>{row.cost}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" className="text-center">
        No Result Found
      </td>
    </tr>
  )}
</tbody>

<tfoot>
  <tr>
    <td colSpan="8" className="text-end fw-bold">
      Total Amount
    </td>
    <td className="fw-bold">
      ₹ {totalAmount.toFixed(2)}
    </td>
  </tr>
</tfoot>
</table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminHome;
